var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    fill: "none",
    viewBox: "0 0 512 512",
    id: "youtube",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B41834",
    d: "M32 160C32 115.817 67.8172 80 112 80H400C444.183 80 480 115.817 480 160V352C480 396.183 444.183 432 400 432H112C67.8172 432 32 396.183 32 352V160Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF2424",
    d: "M32 160C32 115.817 67.8172 80 112 80H384C419.346 80 448 108.654 448 144V336C448 371.346 419.346 400 384 400H96C60.6538 400 32 371.346 32 336V160Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#001F35",
    fillRule: "evenodd",
    d: "M24 160C24 111.399 63.3989 72 112 72H400C448.601 72 488 111.399 488 160V352C488 400.601 448.601 440 400 440H112C63.3989 440 24 400.601 24 352V160ZM112 88C72.2355 88 40 120.236 40 160V352C40 391.764 72.2355 424 112 424H400C439.764 424 472 391.764 472 352V160C472 120.236 439.764 88 400 88H112Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#CBCBCB",
    d: "M340.942 241.827L223.424 180.27C212.771 174.69 200 182.417 200 194.444V317.557C200 329.584 212.771 337.311 223.424 331.731L340.942 270.174C352.376 264.184 352.376 247.817 340.942 241.827Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M336 239.994L223.486 180.428C212.83 174.787 200 182.512 200 194.569V311.994L336 239.994Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#001F35",
    fillRule: "evenodd",
    d: "M192 194.439C192 176.399 211.156 164.808 227.136 173.179L344.654 234.736C361.806 243.72 361.806 268.271 344.654 277.256L227.136 338.813C211.156 347.183 192 335.592 192 317.553V194.439ZM219.712 187.352C214.385 184.562 208 188.426 208 194.439V317.553C208 323.566 214.385 327.429 219.712 324.639L337.23 263.082C342.947 260.088 342.947 251.904 337.23 248.909L219.712 187.352Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.12982f2e6b2d539bfdfb98473859ff28.svg";
export { ForwardRef as ReactComponent };